import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["waterSource", "day", "hoursContainer", "placeholder", "loading", "hourInput", "dayTotal"]
  static values = { eventId: Number, loadUrl: String, saveUrl: String }

  connect() {
    this.updateTotal()
  }

  loadData() {
    const waterSourceId = this.waterSourceTarget.value
    const day = this.dayTarget.value

    if (!waterSourceId || !day) {
      this.showPlaceholder()
      return
    }

    this.showLoading()

    fetch(this.loadUrlValue, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector("[name='csrf-token']").content
      },
      body: JSON.stringify({ water_source_id: waterSourceId, day: day })
    })
    .then(response => response.json())
    .then(data => {
      this.populateHours(data.hours)
      this.showHoursContainer()
      this.updateTotal()
    })
    .catch(error => {
      console.error("Error loading data:", error)
      this.showPlaceholder()
    })
  }

  populateHours(hours) {
    this.hourInputTargets.forEach(input => {
      const hour = parseInt(input.dataset.hour)
      const hourData = hours.find(h => h.hour === hour)
      input.value = hourData ? hourData.liters : 0
    })
  }

  saveData() {
    const waterSourceId = this.waterSourceTarget.value
    const day = this.dayTarget.value

    if (!waterSourceId || !day) return

    const hours = this.hourInputTargets.map(input => ({
      hour: parseInt(input.dataset.hour),
      liters: parseFloat(input.value) || 0
    }))

    fetch(this.saveUrlValue, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector("[name='csrf-token']").content
      },
      body: JSON.stringify({ water_source_id: waterSourceId, day: day, hours: hours })
    })
    .then(response => response.json())
    .then(data => {
      if (data.success) {
        this.showNotification(data.message, "success")
      } else {
        this.showNotification(data.error, "error")
      }
    })
    .catch(error => {
      console.error("Error saving data:", error)
      this.showNotification("Error al guardar", "error")
    })
  }

  updateTotal() {
    const total = this.hourInputTargets.reduce((sum, input) => {
      return sum + (parseFloat(input.value) || 0)
    }, 0)

    if (this.hasDayTotalTarget) {
      this.dayTotalTarget.textContent = total.toFixed(1)
    }
  }

  showPlaceholder() {
    this.placeholderTarget.classList.remove("hidden")
    this.hoursContainerTarget.classList.add("hidden")
    this.loadingTarget.classList.add("hidden")
  }

  showLoading() {
    this.placeholderTarget.classList.add("hidden")
    this.hoursContainerTarget.classList.add("hidden")
    this.loadingTarget.classList.remove("hidden")
  }

  showHoursContainer() {
    this.placeholderTarget.classList.add("hidden")
    this.loadingTarget.classList.add("hidden")
    this.hoursContainerTarget.classList.remove("hidden")
  }

  showNotification(message, type) {
    // Simple alert por ahora, se puede mejorar con toast
    alert(message)
  }
}
